import React, { FC } from 'react';

import { ActionButton, ActionButtonProps } from 'app/components/Button/ActionButton';
import ModalDefault from 'app/components/Modal/ModalDefault';
import Typography from 'app/components/Typography';

interface Props extends ActionButtonProps {
  onCloseModal: () => void;
  onSubmit: () => void;
  title: string;
  label: string;
  styleModalDialog?: React.CSSProperties;
  submitText?: string;
}
const ConfirmationModal: FC<Props> = ({
  label,
  title,
  styleModalDialog,
  onCloseModal,
  onSubmit,
  submitText,
  ...propActionButton
}) => {
  return (
    <ModalDefault
      title={title}
      onClickCloseModal={onCloseModal}
      isConfirmationModal
      styleModalDialog={{
        ...styleModalDialog,
      }}
    >
      <Typography variant="body-3">{label}</Typography>
      <ActionButton
        {...propActionButton}
        isShowButtonReset={false}
        onSubmit={onSubmit}
        labelButtonSubmit={submitText || 'Cancel'}
      />
    </ModalDefault>
  );
};
export default ConfirmationModal;
